import { z } from "zod";

export const listStorageKeys = {
  category: "form-builder-list-category",
  filters: "form-builder-list-filters",
  locations: "form-builder-list-locations",
  matterTypes: "form-builder-list-matterTypes",
  creators: "form-builder-list-creators",
  reminderMessage: "form-builder-list-reminder-message",
  search: "form-builder-list-filter",
} as const;

export const categorySchema = z
  .enum(["lead", "matter", "deleted", "webEnquiry"])
  .optional();
export const filtersSchema = z.array(z.string());
export const locationsSchema = z.array(z.string());
export const matterTypesSchema = z.array(
  z.object({ name: z.string(), category: z.string() }),
);
export const creatorsSchema = z.array(z.string());
export const searchSchema = z.string();

export const reminderMessageFilterSchema = z.enum(["default", "custom"]);
export type ReminderMessageFilter = z.infer<typeof reminderMessageFilterSchema>;
export const reminderMessagesSchema = z.array(reminderMessageFilterSchema);
